'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _cssClasses = require('../helpers/cssClasses');

var _cssClasses2 = _interopRequireDefault(_cssClasses);

var _utils = require('../helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * DOM selectors.
 */
/**
 * Component: Megnav script
 * ------------------------------------------------------------------------------
 * An meganav file that contains scripts to function.
 *
 * @namespace meganav
 */
var selectors = {
  meganav: '[js-menu-drawer="mega-nav"]',
  meganavOpen: '[js-menu-drawer="mega-nav--open"]',
  mobileMenu: '[ js-toggle="menuDrawerTarget"]',
  stickyNav: '[js-site-header="sticky"]',
  miniMenuBack: '[js-menu-drawer="back"]',
  desktopMeganav: '[js-mega-nav="desktop-nav"]',
  siteHeader: '[js-site-header="container"]'
};

/**
 * Create a new example object.
 * @param {object} config - Settings object defined when instantiating.
 */

exports.default = function () {

  /**
   * DOM node selectors.
   */
  var nodeSelectors = {
    meganav: document.querySelectorAll(selectors.meganav),
    meganavOpen: document.querySelectorAll(selectors.meganavOpen),
    stickyNav: document.querySelector(selectors.stickyNav),
    mobileMenu: document.querySelector(selectors.mobileMenu),
    miniMenuBack: document.querySelectorAll(selectors.miniMenuBack),
    desktopMeganav: document.querySelectorAll(selectors.desktopMeganav),
    siteHeader: document.querySelector(selectors.siteHeader)
  };

  /**
   * Initialise component.
   */
  function init() {
    setTriggerEvents();
  }

  /**
   * Set trigger listeners.
   */
  function setTriggerEvents() {

    /**
    * Track top postion of mobile menu with header
    */
    window.addEventListener('scroll', function () {
      return mininavTopPosition(nodeSelectors.mobileMenu);
    });
    Frame.EventBus.listen('Toggle:menuDrawerTarget:open', function () {
      return mininavTopPosition(nodeSelectors.mobileMenu);
    });

    [].concat((0, _toConsumableArray3.default)(nodeSelectors.miniMenuBack)).forEach(function (item) {
      (0, _utils.on)('click', item, function () {
        return megaNavClose();
      });
    });
    [].concat((0, _toConsumableArray3.default)(nodeSelectors.meganavOpen)).forEach(function (item) {
      (0, _utils.on)('click', item, function (event) {
        return megaNavOpen(event, item);
      });
    });

    /**
    * Desktop meganav force site nav white
    */
    [].concat((0, _toConsumableArray3.default)(nodeSelectors.desktopMeganav)).forEach(function (item) {
      (0, _utils.on)('mouseover', item, function () {
        return openMeganavDesktop(item);
      });
      (0, _utils.on)('mouseout', item, function () {
        return closeMeganavDesktop(item);
      });
    });
  }

  /**
   * Set mobilemenu top position.
   */
  function mininavTopPosition(menu) {
    var navTop = nodeSelectors.stickyNav.offsetTop;
    var scrollDistance = window.scrollY;
    var navHitTop = navTop - scrollDistance;
    if (navHitTop >= 0) {
      menu.style.top = nodeSelectors.stickyNav.offsetHeight + navHitTop + 'px';
    } else {
      menu.style.top = nodeSelectors.stickyNav.offsetHeight + 'px';
    }
  }

  function megaNavClose() {
    [].concat((0, _toConsumableArray3.default)(nodeSelectors.meganav)).forEach(function (item) {
      item.classList.remove(_cssClasses2.default.active);
    });
  }

  function megaNavOpen(event, item) {
    event.preventDefault();
    var targetMeganav = item.parentElement.querySelector(selectors.meganav);

    targetMeganav.classList.add(_cssClasses2.default.active);
  }

  function openMeganavDesktop() {
    nodeSelectors.siteHeader.classList.remove(_cssClasses2.default.headerClear);
    window.theme.features.disableClearHeader = true;
  }

  function closeMeganavDesktop() {
    window.theme.features.disableClearHeader = false;
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init: init
  });
};